import useScriptData from '../core/hooks/useScriptData'
import {Disclosure, DisclosureButton, DisclosurePanel} from '@headlessui/react'
import {BaseProps} from "../types";

export default function FaqBlock(props: BaseProps) {
  const data = props.data
  if (Array.isArray(data)) {
    return data.map((item, index) => {
      return (
        <Disclosure key={index}>
          {
            ({ open }) => (
              <div className={'border-b'}>
                <DisclosureButton as={'div'} className={''}>
                  <div
                    className="text-primary flex justify-between items-center text-[20px] leading-[28px] lg:text-[24px] lg:leading-[34px] font-bold py-4 cursor-default">
                    <div>{item.title}</div>
                    <div className="shrink-0 ml-2">
                      {
                        open ? <i className="fa fa-arrow-down"></i> : <i className="fa fa-arrow-up"></i>
                      }

                    </div>
                  </div>
                </DisclosureButton>
                <DisclosurePanel>
                  <div className="mt-[20px] pb-12" dangerouslySetInnerHTML={{__html: item.description}}></div>
                </DisclosurePanel>
              </div>
            )
          }
        </Disclosure>
      )
    })
  }
  return null
}